import { useEffect, useState } from "react";

export interface CountdownState {
  days: number;
  hours: number;
  minutes: number;
  seconds: number;
  isExpired: boolean;
}

function compute(deadline: Date): CountdownState {
  const ms = deadline.getTime() - Date.now();
  if (ms <= 0) {
    return { days: 0, hours: 0, minutes: 0, seconds: 0, isExpired: true };
  }
  const totalSeconds = Math.floor(ms / 1000);
  return {
    days: Math.floor(totalSeconds / 86400),
    hours: Math.floor((totalSeconds % 86400) / 3600),
    minutes: Math.floor((totalSeconds % 3600) / 60),
    seconds: totalSeconds % 60,
    isExpired: false,
  };
}

export function useCountdown(deadline: Date): CountdownState {
  const [state, setState] = useState<CountdownState>(() => compute(deadline));

  useEffect(() => {
    setState(compute(deadline));
    const id = setInterval(() => {
      setState(compute(deadline));
    }, 1000);
    return () => clearInterval(id);
  }, [deadline]);

  return state;
}
